import { Newspaper } from 'lucide-react';

interface UpdateEntry {
  date: string;
  title: string;
  summary: string;
  tag: string;
}

// ─── Entradas de actualizaciones (agregar nuevas al inicio del array) ───
const UPDATES: UpdateEntry[] = [
  {
    date: '10 de agosto de 2026',
    title: 'Nuestra solidaridad con Colombia',
    summary: 'Nos unimos al apoyo por el terremoto de magnitud 7.4 que afectó a Cali, Pereira, Manizales y el Eje Cafetero.',
    tag: 'Comunicado',
  },
];

export function PlatformUpdates() {
  if (UPDATES.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-8">
        <div className="inline-flex items-center space-x-2 mb-3">
          <Newspaper className="w-5 h-5 text-gray-700" />
          <h2 className="text-2xl font-bold text-gray-900">Actualizaciones de DonaApp</h2>
        </div>
        <p className="text-sm text-gray-600">Comunicados y novedades de nuestra plataforma.</p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4">
        {UPDATES.map((entry, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 rounded-lg p-5 hover:border-gray-300 transition-colors"
          >
            <div className="flex items-center space-x-3 mb-2">
              <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-semibold bg-gray-100 text-gray-700">
                {entry.tag}
              </span>
              <span className="text-xs text-gray-400">{entry.date}</span>
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1">{entry.title}</h3>
            <p className="text-sm text-gray-600 leading-relaxed">{entry.summary}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
